export const messages = {
  en: {
    itemOutManage: {
      title: 'Item Out Management',
      queryConditions: 'Query Conditions',
      orderNumber: 'Order Number',
      orderStatus: 'Order Status',
      allStatus: 'All Status',
      unapproved: 'Unapproved',
      approving: 'Approving',
      approved: 'Approved',
      applicantName: 'Applicant Name',
      search: 'Search',
      itemOut: 'Item Out',
      apply: 'Apply',
      operation: 'Operation',
      view: 'View',
      workflowDiagram: 'Workflow Diagram'
    }
  },
  zh: {
    itemOutManage: {
      title: '物品领用管理',
      queryConditions: '查询条件',
      orderNumber: '订单号',
      orderStatus: '订单状态',
      allStatus: '全部状态',
      unapproved: '未审核',
      approving: '审核中',
      approved: '已审核',
      applicantName: '申请人姓名',
      search: '查询',
      itemOut: '物品领用',
      apply: '申请',
      operation: '操作',
      view: '查看',
      workflowDiagram: '流程图'
    }
  }
}